import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { Button, Form } from 'semantic-ui-react';
import { TextField } from '+/components';


const LawyerForm = props => (
    <FinalForm
        validate={validate}
        initialValues={props.initialValues}
        onSubmit={props.onSubmit}
        render={({ handleSubmit, submitting, pristine }) => (
            <Form onSubmit={handleSubmit}>

                <TextField name='name' label='Full Name' />
                <TextField name='address' label='Address' />
                <TextField name='phone_number' label='Phone Number' />
                <TextField name='bar_number' label='Bar Number' />

                <Form.Field>
                    <Button negative onClick={() => props.setModalOpen(false)}>
                            Cancel
                    </Button>
                    <Button floated='right' positive type='submit' disabled={submitting || pristine}>
                            Submit
                    </Button>
                </Form.Field>
            </Form>
        )}
    />
);

const validate = values => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Required';
    }
    if (!values.address) {
        errors.address = 'Required';
    }
    if (!values.phone_number) {
        errors.phone_number = 'Required';
    }
    if (!values.bar_number) {
        errors.bar_number = 'Required';
    }

    return errors;
};


export default LawyerForm;
